module.exports = {
  "/": {
    "name": "invalid-page",
    "success": {
      "default": [
        "BACKUP_LOADED"
      ]
    }
  },
  "/backup": {
    "name": "backup-page",
    "success": {
      "backup page loaded": [
        "BACKUP_LOADED"
      ],
      "backup page pre load": [
        "BACKUP_PRE_LOAD"
      ]
    },
    "error": [
      "BACKUP_LOADED_FAILURE"
    ]
  },
  "/:language/backup": {
    "name": "backup-page-with-language",
    "success": {
      "backup page loaded": [
        "BACKUP_LOADED"
      ],
      "backup page pre load": [
        "BACKUP_PRE_LOAD"
      ]
    },
    "error": [
      "BACKUP_LOADED_FAILURE"
    ]
  },
  "/:language/doi/confirmation": {
    "name": "doi-confirmation-page",
    "success": {
      "doi confirmation page loaded": [
        "DOI_CONFIRMATION"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/manage": {
    "name": "manage-preferences-page",
    "success": {
      "manage preferences page pre load": [
        "MANAGE_PREFERENCES_PRE_LOAD"
      ],
      "manage preferences page loaded": [
        "MANAGE_PREFERENCES_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/unsubscribe": {
    "name": "unsubscribe-all-page",
    "success": {
      "unsubscribe all page pre load": [
        "UNSUBSCRIBE_ALL_PRE_LOAD"
      ],
      "unsubscribe all page loaded": [
        "UNSUBSCRIBE_ALL_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/single": {
    "name": "unsubscribe-single-page",
    "success": {
      "unsubscribe single page pre load": [
        "UNSUBSCRIBE_SINGLE_PRE_LOAD"
      ],
      "unsubscribe single page loaded": [
        "UNSUBSCRIBE_SINGLE_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  },
  "/:language/:route/confirmation": {
    "name": "confirmation-page",
    "success": {
      "confirmation page loaded": [
        "CONFIRMATION_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ],
      "confirmation page pre load": [
        "CONFIRMATION_PRE_LOAD"
      ]
    }
  },
  "/:language/:route/confirmation/preview": {
    "name": "confirmation-preview-page",
    "success": {
      "confirmation preview page pre load": [
        "CONFIRMATION_PREVIEW_PRE_LOAD"
      ],
      "confirmation preview page loaded": [
        "CONFIRMATION_PREVIEW_LOAD"
      ]
    }
  },
  "/:language/contact/:route": {
    "name": "contact-verify-page",
    "success": {
      "contact verify page loaded": [
        "CONTACT_VERIFY_LOAD"
      ],
      "contact verify page pre load": [
        "CONTACT_VERIFY_PRE_LOAD"
      ],
      "backup redirect": [
        "BACKUP_REDIRECT"
      ]
    }
  }
};